export default "__VITE_ASSET__B$ekEDqy__"